import { render, staticRenderFns } from "./RadioButtonGroupView.vue?vue&type=template&id=4844654e&scoped=true"
import script from "./RadioButtonGroupView.vue?vue&type=script&lang=js"
export * from "./RadioButtonGroupView.vue?vue&type=script&lang=js"
import style0 from "./RadioButtonGroupView.vue?vue&type=style&index=0&id=4844654e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4844654e",
  null
  
)

export default component.exports